import { createFileRoute } from '@tanstack/react-router';
import { listSearchSchema } from '@/lib/list-search-schema';
import Customers from '@/pages/Customers';

export const customersSearchSchema = listSearchSchema;

export type CustomersSearch = typeof customersSearchSchema._output;

export const Route = createFileRoute('/_authenticated/customers/')({
  validateSearch: customersSearchSchema,
  component: Customers,
});
